import currencyFormatter from 'currency-formatter';
import _ from 'lodash';
// import dateFormat from 'dateformat';
import moment from 'moment';

export function formatAmount(amount) {
  return currencyFormatter.format(amount, { code: 'AUD' });
}
export function unformatAmount(amount) {
  return parseFloat(amount.replace('$', ''));
}

export function formatBigAmount(amount) {
  return new Intl.NumberFormat('en-AU', {
    style: 'currency',
    currency: 'AUD',
    notation: 'compact',
    compactDisplay: 'short',
  }).format(amount);
}
export function formatNumber(number: number) {
  if (number < 1e3) return number;
  if (number < 1e6) return `${(number / 1e3).toFixed(0)}K`;
  if (number < 1e9) return `${(number / 1e6).toFixed(0)}M`;
  if (number < 1e12) return `${(number / 1e9).toFixed(0)}B`;
  // surely not
  return `${number / 1e12} Tr`;
}

export function parseAmount(amount) {
  return currencyFormatter.format(amount / 100, { code: 'AUD' });
}

export function parseTotal(payment, relevantPaymentCollections) {
  return currencyFormatter.format(
    (payment.amount * relevantPaymentCollections.length) / 100,
    { code: 'AUD' },
  );
}

export function parsePending(payment, relevantPaymentCollections) {
  return relevantPaymentCollections.filter((t) => t.inputStatus === 'pending').length;
}

export function parseCollected(payment, relevantPaymentCollections) {
  return relevantPaymentCollections.filter((t) => t.inputStatus === 'collected')
    .length;
}

export function friendlyDate(dateString = null) {
  const date = dateString === null ? new Date() : new Date(dateString);
  const momentDate = moment(date);
  return momentDate.format('ddd D MMM YYYY - h:mm a');
}

export function friendlyTime(dateString = null) {
  // console.log(dateString);
  const date = dateString === null ? new Date() : new Date(dateString);
  const momentDate = moment(date);
  return momentDate.format('h:mm a');
}

export function friendlyDateTime(dateString = null) {
  // console.log(dateString);
  const date = dateString === null ? new Date() : new Date(dateString);
  const momentDate = moment(date);
  return momentDate.format('h:mm a - D MMM');
}

export function combinedTime(dateString, timeString) {
  const date = dateString === null ? new Date() : new Date(dateString);
  const momentDate = moment(date);

  const time = timeString === null ? new Date() : new Date(timeString);
  const momentTime = moment(time);

  const combinedString = `${momentDate.format('ddd MMM D YYYY')} ${momentTime.format('hh:mm:ss a')}`;

  const combinedDate = new Date(combinedString);
  const momentCombinedDate = moment(combinedDate);

  // console.log(date);
  // console.log(time);
  // console.log(combinedString);
  // console.log(combinedDate);
  return momentCombinedDate.format('ddd MMM D YYYY hh:mm:ss a');
}

export function parseStatus(inputStatus: string): string {
  let parsedText = '';
  if (inputStatus === 'pending') {
    parsedText = 'Pending';
  }
  if (inputStatus === 'paid') {
    parsedText = 'Teammo';
  }
  if (inputStatus === 'active') {
    parsedText = 'Active';
  }
  if (inputStatus === 'cancelled') {
    parsedText = 'Cancelled';
  }
  if (inputStatus === 'collected') {
    parsedText = 'Collected';
  }
  if (inputStatus === 'confirmed') {
    parsedText = 'Confirmed';
  }
  if (inputStatus === 'paid-transferred') {
    parsedText = 'Teammo';
  }
  if (inputStatus === 'paid-refunded') {
    parsedText = 'Refunded';
  }
  if (inputStatus === 'no-show') {
    parsedText = 'No-show';
  }
  if (inputStatus === 'walkover') {
    parsedText = 'Forfeit';
  }
  if (inputStatus === 'cancelled') {
    parsedText = 'Cancelled';
  }
  if (inputStatus === 'paid-cash') {
    parsedText = 'Cash';
  }
  if (inputStatus === 'paid-eftpos') {
    parsedText = 'Eftpos';
  }
  if (inputStatus === 'paid-prepaid') {
    parsedText = 'Pre-paid';
  }
  if (inputStatus === 'transfer-required') {
    parsedText = 'Transfer Pending';
  }
  if (inputStatus === 'transferred') {
    parsedText = 'Transferred';
  }
  if (inputStatus === 'refunded') {
    parsedText = 'Refunded';
  }
  if (inputStatus === 'owing') {
    parsedText = 'Owing';
  }
  if (inputStatus === 'up-to-date') {
    parsedText = 'Up-to-date';
  }
  if (inputStatus === 'overdue') {
    parsedText = 'Overdue';
  }
  return parsedText;
}

export function getTimeFromDateTime(dateString) {
  const date = new Date(dateString);
  const momentDate = moment(date);
  return momentDate.format('h:mm a');
}

export function simpleDate(dateString) {
  const date = new Date(dateString);
  const momentDate = moment(date);
  return momentDate.format('D MMM YYYY - h:mm a');
}
export function simpleDateTwo(dateString) {
  const date = new Date(dateString);
  const momentDate = moment(date);
  return momentDate.format('D MMM YYYY');
}

export function simpleDateNoTime(dateString) {
  const date = new Date(dateString);
  const momentDate = moment(date);
  return momentDate.format('D MMM YYYY');
}

export function superSimpleDate(dateString = null) {
  const date = dateString === null ? new Date() : new Date(dateString);
  const momentDate = moment(date);
  // return momentDate.format('D MMM YY');

  return momentDate.calendar(null, {
    sameDay: '[Today]',
    nextDay: '[Tomorrow]',
    nextWeek: 'D MMM YY',
    lastDay: '[Yesterday]',
    lastWeek: 'D MMM YY',
    sameElse: 'D MMM YY',
  });
}

export function convertToUtc(dateString = null) {
  const date = dateString === null ? new Date() : new Date(dateString);
  const momentDate = moment(date, 'ddd MMM DD YYYY HH:mm:ss GMT+1000 (AEST)');
  const dateInUTC = momentDate.utc();
  return dateInUTC.toString();
}

export function getTimeRange(sinceTime, untilTime = undefined): any {
  const sinceDate = sinceTime === undefined ? new Date() : new Date(sinceTime);
  const untilDate = untilTime === undefined ? sinceDate : new Date(untilTime);
  const sinceDateStart = moment(sinceDate).startOf('day');
  const untilDateEnd = moment(untilDate).endOf('day');
  const sinceTimeParsed = convertToUtc(sinceDateStart.format());
  const untilTimeParsed = convertToUtc(untilDateEnd.format());
  return { sinceTimeParsed, untilTimeParsed };
}

export function convertToUtcDate(dateString = null) {
  const date = dateString === null ? new Date() : new Date(dateString);
  const momentDate = moment(date);

  const dateInUTC = momentDate.utc().format('YYYY-MM-DD z');
  return dateInUTC.toString();
}

export function roundMinutes(date) {
  date.setHours(date.getHours() + Math.round(date.getMinutes() / 60));
  date.setMinutes(0);
  return date;
}

export function mapSelect(objects, id, name) {
  if (_.isEmpty(objects)) {
    return [];
  }
  return _.map(objects, (o) => ({
    id: o[id],
    name: o[name],
  }));
}

export function toTitleCase(str) {
  return str.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());
}

export function friendlyErrorMessage(message) {
  switch (message) {
    case 'Username/client id combination not found.':
      return 'We couldn\'t find that email. Please try again.';
    case 'User does not exist.':
      return 'We couldn\'t find that email. Please try again.';
    default:
      return message;
  }
}
export function parseApiErrors(errors) {
  const errString = _.map(errors, (value, key) => `${value.title}: ${value.detail}`).join(', ');
  return errString;
}
